<div class="loading-overlay" *ngIf="loading">
    <div class="d-flex flex-column justify-content-center align-items-center vh-100 text-light">
        <span class="loader-spinner"></span>
        <h1 class="text-light">Loading</h1>
        <span class="loader-dots"></span>
    </div>
</div>
